import {Inertia} from '@inertiajs/inertia';
import cx from 'classnames';
import React, {useState} from 'react';
import styled from 'styled-components';

import {Button, ButtonSize, ButtonType} from '../../components/crousal/Button';
import {FlashMessage} from '../../components/FlashMessage';
import {H1} from '../../components/crousal/Headings';
import {TextInput} from '../../components/crousal/TextInput';

const ResetPasswordBackgroundImage = styled.div`
 background: url('/images/unrankedsmurfs-login/mobile_loginbg.png');
 background-size: cover;

@media (min-width: 1024px) {
  background: url('/images/unrankedsmurfs-login/login_bg.png');
  background-size: cover;
  }
`;

type Fields = 'username' | 'email' | 'password' | 'password_confirmation';

interface IProps {
    token: string;
    email?: string;
    errors: Record<Fields, string>;
    oldInput: Record<Fields, string>;
}

export function ResetPassword({token, email: initialEmail, errors, oldInput,}: IProps) {
    const [email, setEmail] = useState(initialEmail ?? oldInput.email ?? '');
    const [password, setPassword] = useState('');
    const [passwordConfirmation, setPasswordConfirmation] = useState('');

    const confirmationDoesntMatch =
        password && passwordConfirmation && password !== passwordConfirmation
            ? 'The password confirmation does not match.'
            : undefined;

    function handleReset() {
        Inertia.post('/reset-password', {
            token,
            email,
            password,
            password_confirmation: passwordConfirmation,
        });
    }

    return (
        <ResetPasswordBackgroundImage className="h-screen">
            <div className="h-full flex relative">
                <div className={cx('w-full lg:w-3/5 bg-gray-100', 'pt-100 lg:pt-200')}>
                    <div className="w-4/5 md:w-1/2 xl:w-1/3 mx-auto mt-10">
                        <img src={"/images/unrankedsmurfs-login/login_shield.png"} alt={"shield image"}/>
                        <H1 className="text-smurfs-gold">Reset Password</H1>

                        <div className="font-ubuntu text-18 font-bold leading-tight mt-4">
                            We're almost there.
                        </div>

                        <FlashMessage className="mt-6"/>

                        <TextInput
                            placeholder={"Email Address"}
                            value={email}
                            onChange={setEmail}
                            className="mt-4"
                            error={errors.email}
                        />

                        <TextInput
                            placeholder={"Password"}
                            type="password"
                            value={password}
                            onChange={setPassword}
                            className="mt-4"
                            error={confirmationDoesntMatch ? '' : errors.password}
                        />

                        <TextInput
                            placeholder={"Password Confirmation"}
                            type="password"
                            value={passwordConfirmation}
                            onChange={setPasswordConfirmation}
                            onEnter={handleReset}
                            className="mt-4"
                            error={confirmationDoesntMatch ?? errors.password_confirmation}
                        />

                        <div className="flex mt-6">
                            <Button type={ButtonType.DEFAULT} size={ButtonSize.DEFAULT} onClick={handleReset}>
                                Reset
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </ResetPasswordBackgroundImage>
    );
}
